import type { UsageByDateBreakdown } from '@vy/types';
import { vyDate } from '@vy/utils';
import type { UsageDataItem } from '../../../../hooks/use-customer-portal-chart-data-utils';

export function mapUsageDataToUsageByDateBreakdown(
  usageData: UsageDataItem[],
): UsageByDateBreakdown[] {
  const groupedByMonth = groupByMonth(usageData);

  return Array.from(groupedByMonth.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([, items]) => buildUsageByDateBreakdown(items));
}

function groupByMonth(usageData: UsageDataItem[]): Map<string, UsageDataItem[]> {
  const grouped = new Map<string, UsageDataItem[]>();

  for (const item of usageData) {
    const monthKey = vyDate(item.date).format('YYYY-MM');
    const existing = grouped.get(monthKey);

    if (existing) {
      existing.push(item);
    } else {
      grouped.set(monthKey, [item]);
    }
  }

  return grouped;
}

function buildUsageByDateBreakdown(items: UsageDataItem[]): UsageByDateBreakdown {
  const representativeDate = items[0].date;
  let totalUnits = 0;

  const customerUsage = items.map((item) => {
    totalUnits += item.totalValue;

    return {
      customerId: item.productName,
      customerName: item.productName,
      units: item.totalValue,
    };
  });

  return {
    date: representativeDate,
    units: totalUnits,
    customerUsage,
  };
}
